// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "picture{display:flex;align-items:stretch}picture img{flex-grow:1}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
